import { useSelectedChain } from "@app/examples/ChainSelector"
import { PaginationBar } from "@components/PaginationBar"
import { NftCardV2 } from "@components/nft/NftCardV2"
import { useApi } from "@hooks/ApiHook"
import { UserResponse } from "baaanggg"
import React, { useState } from "react"

type Props = {
    user: UserResponse
}

export function MyNftTab({ user }: Props) {
    const [page, setPage] = useState(1)
    const { data: paginatedNft } = useApi(api => api.item.allNft({ ownerAddress: user.walletAddress, page: page }), [page, user])

    return <div>
        <div className="grid grid-cols-1 gap-[1.875rem] md:grid-cols-3 lg:grid-cols-4 js-collections-grid">
            {
                paginatedNft?.data.map(nft => {
                    return <NftCardV2 nft={nft} />
                })
            }
        </div>

        <div className="mt-5"></div>

        {
            paginatedNft && <PaginationBar
                pagination={paginatedNft}
                currentPage={page}
                onPageChange={page => setPage(page)} />
        }
    </div>
}